module.exports = __webpack_public_path__ + "static/media/news__002.8bac92bf.jpg";